module.exports = __webpack_public_path__ + "img/Muhammad Ali at GPG house.2d8cf531.png";